import { getPerformanceEntries } from './collectFromPerfMarkers.ts';

/**
 * Collects `wf/` performance entries and pairs matching `.start` / `.end`
 * marks into timing objects.
 *
 * For each pair `wf/<key>.start` and `wf/<key>.end`, produces an entry
 * `{ [key]: { startTime, endTime } }`.
 *
 * Unpaired marks (a `.start` without a matching `.end` or vice versa) are
 * ignored.
 */
export function getWaterfallTimings(): Record<string, { startTime: number; endTime: number }> {
	const entries = getPerformanceEntries('wf/');
	const startTimes: Record<string, number> = {};
	const timings: Record<string, { startTime: number; endTime: number }> = {};

	for (const { name, startTime } of entries) {
		if (name.endsWith('.start')) {
			const key = name.slice(0, -'.start'.length);
			startTimes[key] = startTime;
		} else if (name.endsWith('.end')) {
			const key = name.slice(0, -'.end'.length);
			if (typeof startTimes[key] === 'number') {
				timings[key] = { startTime: startTimes[key], endTime: startTime };
			}
		}
	}

	return timings;
}
